import { useQuery } from "react-query";

import { getListOfGoals } from "api/goals";
import { GET_LIST_OF_GOALS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";

/**
 * Custom hook to fetch the list of goals for a specific client.
 * @param clientId - The ID of the client whose goals are to be fetched.
 * @param params - Optional parameters for fetching goals (e.g., includeArchived).
 * @returns An object containing the list of goals, total count, loading state, and any error encountered.
 */
const useGetListOfGoals = (clientId: string, params: { includeArchived?: boolean }) => {
  const {
    data: response,
    error,
    isLoading,
    ...rest
  } = useQuery(
    [GET_LIST_OF_GOALS, clientId, params],
    () => getListOfGoals(clientId, params ?? {}),
    {
      enabled: !!clientId,
      staleTime: STALE_TIME_5_MINUTES,
      refetchOnWindowFocus: false,
      retry: 2, // Retry failed requests up to 2 times
    }
  );

  return {
    goals: response?.data || [],
    errorGoals: error,
    isGoalsLoading: isLoading,
    ...rest,
  };
};

export default useGetListOfGoals;
